import { render, staticRenderFns } from "./BikeConfiguration.vue?vue&type=template&id=059c9a75"
import script from "./BikeConfiguration.vue?vue&type=script&lang=js"
export * from "./BikeConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports